module.exports = {
  title: 'Speech Analytics'
}
